import * as React from 'react';

import { SearchField, Select } from '@rematter/ui-web';
import { useAtom, useSetAtom } from 'jotai';

import * as state from '../../_state/financialAccounts.state';

import { useTranslations } from '@/finance/i18n/useTranslations';
import { useDebouncedAtom } from '~/shared/hooks/useDebouncedAtom';

//
// ⚛️ ⚛️ ⚛️ FINANCIAL ACCOUNT LIST FILTER BAR ⚛️ ⚛️ ⚛️
//
export const FinancialAccountListFilterBar = () => {
  const t = useTranslations();

  // Atoms
  const [searchTerm, setSearchTerm] = useDebouncedAtom(state.$searchTerm, 500);
  const [selectedType, setSelectedType] = useAtom(state.$selectedType);
  const setOffset = useSetAtom(state.$offset);

  // Memoized values
  const typeOptions: Array<{ key: string; label: string }> = React.useMemo(
    () => [
      {
        key: 'all',
        label: t.financialAccounts.list.typeFilter.options.all,
      },
      {
        key: 'Cash',
        label: t.financialAccounts.list.typeFilter.options.cash,
      },
      {
        key: 'Checking',
        label: t.financialAccounts.list.typeFilter.options.checking,
      },
      {
        key: 'Savings',
        label: t.financialAccounts.list.typeFilter.options.savings,
      },
    ],
    [
      t.financialAccounts.list.typeFilter.options.all,
      t.financialAccounts.list.typeFilter.options.cash,
      t.financialAccounts.list.typeFilter.options.checking,
      t.financialAccounts.list.typeFilter.options.savings,
    ],
  );

  // Callbacks
  const handleSearch = React.useCallback(
    (value: string) => {
      setSearchTerm(value);
      setOffset(0);
    },
    [setSearchTerm, setOffset],
  );
  const handleTypeChange = React.useCallback(
    (key: React.Key) => {
      setSelectedType(key === 'all' ? undefined : String(key));
      setOffset(0);
    },
    [setSelectedType, setOffset],
  );

  return (
    <>
      <SearchField
        autoFocus
        aria-label={t.financialAccounts.list.search.label}
        className="min-h-0 w-80"
        placeholder={t.financialAccounts.list.search.placeholder}
        value={searchTerm ?? ''}
        onChange={(value) => handleSearch(value ?? '')}
      />
      <Select
        value={selectedType ?? 'all'}
        onChange={(key) => handleTypeChange(key as React.Key)}
        options={typeOptions}
        placeholder={t.financialAccounts.list.typeFilter.label}
        className="w-40"
      />
    </>
  );
};
